import api from '../api';
import { TBookieProfile } from './profile.types';

export const profileEndpoint = 'bookie/settings/profile';

export const queryProfile = () =>
  api.get<TBookieProfile>(profileEndpoint).then((res) => res.data);
